module.exports = __webpack_public_path__ + "static/rabus-3df660ea1d399712594b36f0d037c56f.png";